import Tooltip from '../../Tooltip';
import SyncStatusPanel from './SyncStatusPanel';
import { SYNC_MODES } from './syncStatusUtils';
import styles from '../GirderConnection.module.css';

/**
 * Secondary manual sync: full or selective pull + status/diff review.
 */
export default function ManualSyncPanel({
    syncMode,
    onSyncModeChange,
    isSyncInProgress,
    connectionId,
    folderId,
    onFullSync,
    onCheckForChanges,
    onSyncSelected,
    onResetSync,
    syncRemotePending,
    fetchDiffPending,
    resetSyncPending,
    selectedCount,
    syncRecordStatus,
    isStuck,
    remoteName,
    syncRecord,
    diffReview,
    syncError,
    onDismissError,
    onDiscardDiff,
    selectedUuids,
    onSelectionChange,
}) {
    return (
        <div className={styles.manualSyncBody} data-sourcepanel="ManualSyncPanel.js">
            <div className={styles.manualScopeSelector} role="radiogroup" aria-label="Manual sync scope">
                <button
                    type="button"
                    role="radio"
                    aria-checked={syncMode === SYNC_MODES.FULL}
                    className={`${styles.manualScopeOption} ${syncMode === SYNC_MODES.FULL ? styles.manualScopeOptionActive : ''}`}
                    onClick={() => !isSyncInProgress && onSyncModeChange(SYNC_MODES.FULL)}
                    disabled={isSyncInProgress}
                >
                    All changes
                </button>
                <button
                    type="button"
                    role="radio"
                    aria-checked={syncMode === SYNC_MODES.SELECTIVE}
                    className={`${styles.manualScopeOption} ${syncMode === SYNC_MODES.SELECTIVE ? styles.manualScopeOptionActive : ''}`}
                    onClick={() => !isSyncInProgress && onSyncModeChange(SYNC_MODES.SELECTIVE)}
                    disabled={isSyncInProgress}
                >
                    Choose what to sync
                </button>
            </div>

            <div className={styles.syncActionsRow}>
                {syncMode === SYNC_MODES.FULL && (
                    <button
                        type="button"
                        className={styles.syncButton}
                        onClick={onFullSync}
                        disabled={!connectionId || syncRemotePending || (syncRecordStatus === 'in_progress' && !isStuck)}
                    >
                        {syncRemotePending ? 'Syncing…' : 'Sync now'}
                    </button>
                )}
                {syncMode === SYNC_MODES.SELECTIVE && (
                    <>
                        <button
                            type="button"
                            className={styles.syncButton}
                            onClick={onCheckForChanges}
                            disabled={!connectionId || fetchDiffPending || isSyncInProgress}
                        >
                            {fetchDiffPending ? 'Checking…' : 'Check for changes'}
                        </button>
                        <button
                            type="button"
                            className={styles.syncButtonSecondary}
                            onClick={onSyncSelected}
                            disabled={!connectionId || selectedCount === 0 || syncRemotePending || isSyncInProgress}
                        >
                            {syncRemotePending ? 'Syncing…' : `Sync selected (${selectedCount})`}
                        </button>
                    </>
                )}
                <Tooltip
                    text={isSyncInProgress
                        ? 'Warning: This is intended for use when a server error causes the sync record to be stuck in an incorrect state. This will NOT stop any ongoing sync operations.'
                        : 'Reset sync status is only available when a sync is in progress'
                    }
                    position="top"
                >
                    <button
                        type="button"
                        className={`${styles.resetButton} ${styles.syncActionReset}`}
                        onClick={onResetSync}
                        disabled={resetSyncPending || !folderId || !isSyncInProgress}
                    >
                        {resetSyncPending ? 'Resetting...' : 'Reset sync'}
                    </button>
                </Tooltip>
            </div>

            <SyncStatusPanel
                remoteName={remoteName}
                syncRecord={syncRecord}
                diffReview={diffReview}
                syncError={syncError}
                isSyncInProgress={isSyncInProgress}
                onDismissError={onDismissError}
                onDiscardDiff={onDiscardDiff}
                selectedUuids={selectedUuids}
                onSelectionChange={onSelectionChange}
            />
        </div>
    );
}
